import { AsyncPipe, NgIf } from '@angular/common';
import { Component, OnInit, ViewEncapsulation, inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, UntypedFormGroup, Validators } from '@angular/forms';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogConfig } from '@angular/material/dialog';
import { MatError, MatFormField, MatHint } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatToolbar } from '@angular/material/toolbar';
import { ErrorService } from '@portal-core/errors/services/error.service';
import { ErrorsExpansionPanelComponent } from '@portal-core/general/components/errors-expansion-panel/errors-expansion-panel.component';
import { LoaderComponent } from '@portal-core/general/components/loader/loader.component';
import { LicenseUser } from '@portal-core/license-users/models/license-user.model';
import { License } from '@portal-core/licenses/models/license.model';
import { LicensesService } from '@portal-core/licenses/services/licenses.service';
import { DialogBase } from '@portal-core/ui/dialog/util/dialog.base';
import { SnackBarAutoDismissDurationMS } from '@portal-core/ui/snack-bar/constants/snack-bar-auto-dismiss-duration.constant';
import { McColorDirective } from '@portal-core/ui/themes/directives/mc-color.directive';
import { LoadingState } from '@portal-core/util/loading-state';

export interface LicenseContactSalesDialogData {
  license: License;
  licenseUser: LicenseUser;
}

@Component({
  selector: 'mc-license-contact-sales-dialog',
  templateUrl: './license-contact-sales-dialog.component.html',
  styleUrls: ['./license-contact-sales-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [ReactiveFormsModule, MatToolbar, MatIconButton, MatIcon, MatFormField, McColorDirective, MatInput, MatHint, NgIf, MatError, ErrorsExpansionPanelComponent, MatButton, LoaderComponent, AsyncPipe]
})
export class LicenseContactSalesDialogComponent extends DialogBase<LicenseContactSalesDialogComponent, void> implements OnInit {
  private readonly data = inject<LicenseContactSalesDialogData>(MAT_DIALOG_DATA);
  private readonly licensesService = inject(LicensesService);
  private readonly errorService = inject(ErrorService);
  private readonly snackBar = inject(MatSnackBar);

  static DialogConfig: MatDialogConfig = {
    width: '96rem',
    height: '72rem'
  };

  license: License;
  licenseUser: LicenseUser;

  contactForm: UntypedFormGroup;
  message: FormControl;

  savingState: LoadingState<string> = new LoadingState<string>();

  override ngOnInit() {
    super.ngOnInit();

    this.license = this.data.license;
    this.licenseUser = this.data.licenseUser;

    this.buildForm();
  }

  private buildForm() {
    this.contactForm = new FormGroup({
      message: new FormControl('', [Validators.required, Validators.maxLength(2000)])
    });
  }

  onSubmit() {
    this.savingState.update(true);

    const message = this.contactForm.get('message')?.value;

    this.licensesService.emailMadCapSalesTeam$(this.license.Id, message)
      .subscribe(() => {
        this.savingState.update(false);

        this.snackBar.open('Email has been sent.', 'OK', {
          duration: SnackBarAutoDismissDurationMS
        });
        this.closeDialog();
      },
        error => {
          this.savingState.update(false, 'Failed to send email.', this.errorService.getErrorMessages(error));
        });
  }
}
